import React, {useState , useRef, useEffect} from "react";

const PartSecondTab = ({selectedAnswersPartII, setSelectedAnswersPartII})=>{

const questionRefs = useRef([]);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    const questions = [
      { n: 1, id: 27, text: "Select what appeals better?", options: ["SCHEDULED", "UNPLANNED"] },
      { n: 2, id: 28, text: "Select what appeals better?", options: ["FACTS", "IDEAS"] },
      { n: 3, id: 29, text: "Select what appeals better?", options: ["QUIET", "HEARTY"] },
      { n: 4, id: 30, text: "Select what appeals better?", options: ["CONVINCING", "TOUCHING"] },
      { n: 5, id: 31, text: "Select what appeals better?", options: ["IMAGINATIVE", "MATTER-OF-FACT"] },
      { n: 6, id: 32, text: "Select what appeals better?", options: ["BENEFITS", "BLESSINGS"] },
      { n: 7, id: 33, text: "Select what appeals better?", options: ["PEACEMAKER", "JUDGE"] },
      { n: 8, id: 34, text: "Select what appeals better?", options: ["SYSTEMATIC", "SPONTANEOUS"] },
      { n: 9, id: 35, text: "Select what appeals better?", options: ["STATEMENT", "CONCEPT"] },
      { n: 10, id: 36, text: "Select what appeals better?", options: ["RESERVED", "TALKATIVE"] },
      { n: 11, id: 37, text: "Select what appeals better?", options: ["ANALYZE", "SYMPATHIZE"] },
      { n: 12, id: 38, text: "Select what appeals better?", options: ["CREATE", "MAKE"] },
      { n: 13, id: 39, text: "Select what appeals better?", options: ["DETERMINED", "DEVOTED"] },
      { n: 14, id: 40, text: "Select what appeals better?", options: ["GENTLE", "FIRM"] },
      { n: 15, id: 41, text: "Select what appeals better?", options: ["SYSTEMATIC", "CASUAL"] },
      { n: 16, id: 42, text: "Select what appeals better?", options: ["CERTAINTY", "THEORY"] },
      { n: 17, id: 43, text: "Select what appeals better?", options: ["CALM", "LIVELY"] },
      { n: 18, id: 44, text: "Select what appeals better?", options: ["JUSTICE", "MERCY"] },
      { n: 19, id: 45, text: "Select what appeals better?", options: ["FASCINATING", "SENSIBLE"] },
      { n: 20, id: 46, text: "Select what appeals better?", options: ["FIRM-MINDED", "WARM-HEARTED"] },
      { n: 21, id: 47, text: "Select what appeals better?", options: ["FEELING", "THINKING"] },
      { n: 22, id: 48, text: "Select what appeals better?", options: ["LITERAL", "FIGURATIVE"] },
      { n: 23, id: 49, text: "Select what appeals better?", options: ["FORESIGHT", "COMPASSION"] },
      { n: 24, id: 50, text: "Select what appeals better?", options: ["HARD", "SOFT"] }
    ];
    
      

    
  const handleAnswerChange = (questionNumber, option, number) => {
    setSelectedAnswersPartII((prevAnswers) => {
      const newAnswers = {
        ...prevAnswers,
        [questionNumber]: prevAnswers[questionNumber] === option ? null : option, // Deselect if the same answer is clicked
      };

      // Automatically scroll to the next question
      const nextQuestionIndex = number; // index starts from 0, id starts from 1
      if (questionRefs.current[nextQuestionIndex]) {
        questionRefs.current[nextQuestionIndex].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return newAnswers;
    });
  };



    return(

        <div className="container mx-auto px-6 py-8">
        <h1 className=" parts pl-24 pr-24 question-header text-gray-800 text-left mb-12">
        
        Which word in each pair appeals to you more? (Think what the word means, not how they look or how they sound).


        </h1>
        <div className="parts pl-24 pr-24 text-gray-800">


        {questions.map((question, index) => (
        <div key={question.id}
        ref={(el) => (questionRefs.current[index] = el)}
        className="p-6 mb-6 bg-white shadow-lg ">
          <h2 className="question-text text-gray-700 mb-4">
            Question {question.n}: {question.text}
          </h2>
          
           {question.options.map((option, optionIndex) => {
            const optionLabel = String.fromCharCode(65 + optionIndex); 

            return(

            <div
            className="mb-6"
          >
              <button
                key={optionIndex}
                onClick={() => handleAnswerChange(question.id, optionLabel, question.n)}
                className={` text-left py-3 px-6 option-text rounded-lg focus:outline-none transition duration-200 ${
                  selectedAnswersPartII[question.id] === optionLabel
                    ? "bg-green-500 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {optionIndex + 1}. {option}
              </button>
              </div>
            )
})}
          </div>
        
      ))}
      </div>

        </div>
  
    )

}

export default PartSecondTab;